<ng-container>
  <div class="header" *ngIf="getHeader()">
    <div class="menu_toggle" appChangeColorTheme attribute="bgc">
      <fa-icon [icon]="getFaIcon('faBars')" (click)="drawer.toggle()"></fa-icon>
    </div>
    <app-nav></app-nav>
  </div>

  <mat-drawer-container class="container">
    <mat-drawer #drawer class="sidenav" mode="over" appChangeColorTheme attribute="bgc">
      <ul>
        <li *ngFor="let m of mainMenu" [routerLink]="[m.url]" routerLinkActive="router-link-active"
          (click)="getRouteNavigate(m.url); drawer.toggle()">
          <fa-icon [icon]="getFaIcon(m.faIcon)"></fa-icon>
          {{m.name}}
        </li>
        <div class="produce_by_mobile">


          <span>Powered by</span>
          <div class="bizzdev">
            <img src="/assets/img/icone/logo_bizzdev.jpg" alt="">
            <a href="https://www.bizzdev.com/" target="_blank"> BizzDev</a>
          </div>
        </div>
        <div class="policyLinkContainer">
          <a href="https://www.lvhdf.fr/index.php/privacy" class="policyLink" target="_blank">Politique de
            confidentialité</a>
        </div>
        <div>
          Version: {{appVersion}}
        </div>
      </ul>

    </mat-drawer>

    <div class="sidenav-content">

      <div [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''" class="app_router_outlet" (click)="resetPopUp()">
        <router-outlet #o="outlet"></router-outlet>
      </div>
    </div>

  </mat-drawer-container>

  <div class="produce_by_desktop_left" *ngIf="showProduce">

    <div class="policyLinkContainer">
      <a href="https://www.lvhdf.fr/index.php/privacy" class="policyLink" target="_blank">Politique de
        confidentialité</a>
    </div>
    <span>Powered by</span>
    <div class="bizzdev">
      <img src="/assets/img/icone/logo_bizzdev.jpg" alt="">
      <a href="https://www.bizzdev.com/" target="_blank"> BizzDev</a>
    </div>
    <div>
      Version: {{appVersion}}
    </div>


  </div>

  <div class="produce_by_desktop_right" *ngIf="!showProduce">
    <div class="policyLinkContainer">
      <a href="https://www.lvhdf.fr/index.php/privacy" class="policyLink" target="_blank">Politique de
        confidentialité</a>
    </div>
    <span>Powered by</span>
    <div class="bizzdev">
      <img src="/assets/img/icone/logo_bizzdev.jpg" alt="">
      <a href="https://www.bizzdev.com/" target="_blank"> BizzDev</a>
    </div>
    <div>
      Version: {{appVersion}}
    </div>
  </div>

</ng-container>